import { useTheme } from "@mui/styles";
import ButtonBase from "@mui/material/ButtonBase";
import React from "react";
import { combineClassNames } from "../../../../utils/styling.utils";

const PainPointButton = ({ className, children, onClick, index }) => {
  const theme = useTheme();
  const handleOnClick = () => {
    onClick(index);
  };

  const combinedClasses = combineClassNames(
    "row",
    "justify-content-center",
    "align-items-start",
    className
  );

  return (
    <ButtonBase
      className={combinedClasses + ' pain-point-button'}
      style={{
        borderColor: "transparent",
        ":hover": {
          backgroundColor: theme.COLORS.BLUE.darkBlueGreen,
          color: "white",
        },
        borderRadius: "20px",
        height: "10vh",
      }}
      onClick={handleOnClick}
    >
      {children}
    </ButtonBase>
  );
};

export default PainPointButton;
